module.exports = __webpack_public_path__ + "media/images/sp/components/specials/campaign_card/detail_link-884e5d63dcd4fa6f8e7bedfea9102746.png";